import { api } from '@/api/cliente';

/**
 * Imprime el ticket de 80 mm en un iframe oculto (la impresora térmica se elige en el diálogo
 * del navegador). Se imprime desde esta ventana para no depender de scripts dentro del ticket.
 */
export async function imprimirTicket(ventaId: string): Promise<void> {
  const blob = await api<Blob>(`/ventas/${ventaId}/ticket`);
  const html = (await blob.text()).replace(' onload="window.print()"', '');
  const iframe = Object.assign(document.createElement('iframe'), { title: 'Ticket', srcdoc: html });
  Object.assign(iframe.style, { position: 'fixed', right: '0', bottom: '0', width: '0', height: '0', border: '0' });
  document.body.appendChild(iframe);
  await new Promise<void>((ok) => iframe.addEventListener('load', () => ok(), { once: true }));
  iframe.contentWindow?.focus();
  iframe.contentWindow?.print();
  setTimeout(() => iframe.remove(), 60_000);
}
